import "@hassanmojab/react-modern-calendar-datepicker/lib/DatePicker.css";
import { useRoutes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "./App.css";
import { MainProvider } from "./context/MainContext";
import routes from "./routes";

function App() {
  let router = useRoutes(routes);
  return (
    <>
      <MainProvider>
        <main>{router}</main>
        <ToastContainer
          position="top-center"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={true}
        />
      </MainProvider>
    </>
  );
}

export default App;
